<template>
  <b-input-group>
    <b-form-input
      v-model="password"
      :readonly="readonly"
      :type="showCurrentPassword ? 'text' : 'password'"
      :state="state"
      :autocomplete="autocomplete"
      :name="name"
      :maxlength="maxlength"
      :required="required"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @blur="$emit('blur', $event)"
    />
    <b-input-group-append>
      <b-input-group-text @click="toggleShowCurrentPassword">
        <i
          style="font-size: 16px"
          :class="showCurrentPassword ? 'icon-visibility-off' : 'icon-visibility'"
        />
      </b-input-group-text>
    </b-input-group-append>
    <slot />
  </b-input-group>
</template>

<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import { BInputGroup, BInputGroupText, BInputGroupAppend } from 'bootstrap-vue'

export default defineComponent({
  name: 'InputPassword',
  components: {
    BInputGroup,
    BInputGroupText,
    BInputGroupAppend
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    name: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const showCurrentPassword = ref(false)
    const password = computed({
      get: () => props.value,
      set: (value) => emit('input', value)
    })

    function toggleShowCurrentPassword() {
      showCurrentPassword.value = !showCurrentPassword.value
    }

    return {
      password,
      showCurrentPassword,
      toggleShowCurrentPassword
    }
  }
})
</script>
<style lang="scss" scoped>
.input-group-text {
  background-color: white;
  cursor: pointer;
}
</style>
